// ─── Styles ───────────────────────────────────────────────────────────────────
import '../scss/style.scss';

// ─── Alpine.js ────────────────────────────────────────────────────────────────
import Alpine from 'alpinejs';

// ─── Local modules ────────────────────────────────────────────────────────────
import { initNavigation, initMobileSubmenu, initStickyHeader } from './modules/navigation.js';

// ─── Boot ─────────────────────────────────────────────────────────────────────
document.addEventListener( 'DOMContentLoaded', () => {
	initNavigation();
	initMobileSubmenu();
	initStickyHeader();
} );

Alpine.start();
